import { noop } from 'lodash/fp';
import { connect } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { ContentCard } from '@mews-commander/ui';
import AddProductForm from '../AddProductForm';

const AddProductFormCard = (props: $TSFixMe) => (
    <ContentCard title={<LocalizedText textKey={TextKey.AddProduct} />}>
        {/* @ts-expect-error $TSFixMeError: JSX element type 'AddProductForm' does not have any construct or call signatures. */}
        <AddProductForm {...props} />
    </ContentCard>
);

// @ts-expect-error $TSFixMeError: Property 'refetchGroup' does not exist on type '{}'.
export default connect(undefined, (dispatch, { refetchGroup = noop }) => ({
    onSuccess: () => {
        refetchGroup();
        showSuccessAlert({ description: lt('AddProductOrderSuccessMessage') });
    },
}))(AddProductFormCard);
